import {
	AppBar,
	Button,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Toolbar,
	useTheme,
} from '@mui/material';
import React from 'react';

import {BookingScriptFlowEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {StyledDialog, StyledDialogActions, StyledStack} from './styles';
import {ScriptModalProps} from './types';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {Loading} from 'presentation/components/Loading/Loading';

const {headerTitle, title, description, content, button1, button2} =
	translations['pt-br'].privateFlow.bookingFlow.scriptModal;

export function ScriptModal({open, setOpen, handleNext}: ScriptModalProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const setBookingData = useBookingStore(state => state.setBookingData);

	const theme = useTheme();
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	function resetSpecialtySelection() {
		setBookingData(prev => ({
			...prev,
			specialtyCode: '',
			specialtyName: '',
			subSpecialtyCode: '',
		}));
	}

	function handleClose() {
		setOpen(false);
		resetSpecialtySelection();
	}

	async function handleCallChat() {
		await callChatRoom(ChatRoomsEnum.APP);
		setOpen(false);
		resetSpecialtySelection();
	}

	return (
		<StyledDialog
			open={open}
			onClose={handleClose}
			data-tag-id={BookingScriptFlowEnum.VISUALIZOU_SUGESTAO_AGENDAMENTO}>
			<AppBar elevation={0} position="relative">
				<Toolbar disableGutters>
					<DialogTitle variant="h6" sx={{flex: 1}}>
						{headerTitle}
					</DialogTitle>

					<IconButton
						onClick={handleClose}
						style={{marginRight: 4}}
						aria-label="close"
						color="inherit"
						size="large"
						data-tag-id={BookingScriptFlowEnum.CLICK_FECHAR_AGENDAMENTO_SUGERIDO}>
						<Icon name="close-filled" color={theme.palette.other.closeIcon} />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent sx={{p: 3}}>
				<DialogTitle
					textAlign="center"
					sx={{
						p: 0,
						mb: 2,
					}}>
					{title} <br />
					{formatText(bookingData.specialtyName)}
				</DialogTitle>

				<DialogContentText mb={3} textAlign="center" color="text.primary">
					{content} {formatText(bookingData.specialtyName)}.
				</DialogContentText>
				<DialogContentText textAlign="center" color="text.primary">
					{description}
				</DialogContentText>
			</DialogContent>
			<StyledDialogActions>
				<StyledStack>
					<Button
						fullWidth
						size="large"
						onClick={handleNext}
						data-tag-id={BookingScriptFlowEnum.CLICK_PROSSEGUIR_COM_SUGESTAO}>
						{button1}
					</Button>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						onClick={handleCallChat}
						data-tag-id={BookingScriptFlowEnum.CLICK_INICIAR_CHAT_SUGESTAO_AGENDAMENTO}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}
						disabled={callChatRoomIsLoading}>
						{button2}
					</Button>
				</StyledStack>
			</StyledDialogActions>
		</StyledDialog>
	);
}
